import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-8" }
const _hoisted_2 = { class: "text-xl font-semibold text-center outline-none" }
const _hoisted_3 = { class: "space-y-2" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center gap-2 rounded-md bg-yellow-50 px-3 py-2 text-sm text-yellow-800 ring-1 ring-yellow-300"
}
const _hoisted_5 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomSelect = _resolveComponent("CustomSelect")!
  const _component_CustomButton = _resolveComponent("CustomButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.title')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_CustomSelect, {
        value: _ctx.computedValue.location,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedValue.location) = $event)),
        label: _ctx.$t('views.feed.reconciliations.newModal.locationFieldLabel'),
        "return-object": "",
        groups: true,
        items: _ctx.locationOptions,
        "item-text": "name",
        "item-value": "name",
        "group-key": "barns",
        "group-text-key": "name",
        "group-select-options": _ctx.farmSelectOptions,
        "sub-group-key": "batches",
        "sub-group-text-key": "name",
        "sub-group-select-options": _ctx.barnSelectOptions,
        "sub-group-item-select-options": _ctx.batchSelectOptions,
        "show-required-indication": false,
        "allow-empty": false
      }, null, 8, ["value", "label", "items", "group-select-options", "sub-group-select-options", "sub-group-item-select-options"]),
      _createVNode(_component_CustomSelect, {
        value: _ctx.computedValue.fromStatusDate,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedValue.fromStatusDate) = $event)),
        label: _ctx.$t('views.feed.reconciliations.newModal.fromDateFieldLabel'),
        items: _ctx.fromDateOptions,
        "item-text": "label",
        "item-value": "value",
        disabled: _ctx.isBatchSelected || !_ctx.computedValue.location,
        "show-required-indication": false,
        "allow-empty": false
      }, null, 8, ["value", "label", "items", "disabled"]),
      _createVNode(_component_CustomSelect, {
        value: _ctx.computedValue.toStatusDate,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedValue.toStatusDate) = $event)),
        label: _ctx.$t('views.feed.reconciliations.newModal.toDateFieldLabel'),
        items: _ctx.toDateOptions,
        "item-text": "label",
        "item-value": "value",
        disabled: _ctx.isBatchSelected || !_ctx.computedValue.fromStatusDate,
        "show-required-indication": false,
        "allow-empty": false
      }, null, 8, ["value", "label", "items", "disabled"])
    ]),
    (_ctx.noToDateOptionsAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "h-4 w-4 shrink-0",
            viewBox: "0 0 20 20",
            fill: "currentColor",
            "aria-hidden": "true"
          }, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z",
              "clip-rule": "evenodd"
            })
          ], -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.allPeriodsReconciled')), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_CustomButton, {
        class: "min-w-44",
        disabled: !_ctx.canProceed,
        onClick: _ctx.onContinueClicked
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('views.feed.reconciliations.newModal.continueButton')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}